import React, { useState, Fragment, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { CommonConfig } from '../../../config/common-config';
import axios from 'axios';
import { Button, Paper } from '@material-ui/core';
import InputForm from './components/InputForm';
import EditForm from './components/EditForm';
import TableUser from './components/TableUser';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import './styles.css';

export default function AddAdditional() {
    const serviceIdSelected = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName.tennantName);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const user_token = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${user_token}`;

    const history = useHistory();
    const usersData = [];
    const [users, setUsersData] = useState(usersData);
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[5].branchName;
    const imcNameSelected = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);

    const tennantname = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantnameValue = tennantname && tennantname.tennantName;

    const [isEditing, setEditing] = useState(false);
    // const initialFormState = { id: null, name: '', attachment: '',test:'' }
    const initialFormState = {
        questionId: null,
        questionText: '',
        response: '',
        isAttachmentRequired: '',
        attachmentUrls: [],
        relevantFlag: '',
        relevanceResponseCRC: '',
        relevanceRemarksCRC: '',
        relevanceResponseAM: '',
        relevanceRemarksAM: '',
        autoPopulate: 'true',
    };
    const [currentUser, setCurrentUser] = useState(initialFormState);
    const getadditionalQuestions = (bearerToken) => {
        axios
            .get(`${CommonConfig.dev.baseUrl1}/api/itr/additional-question/${(usertype === 'Ultimate Client' || usertype === 'EM') ? tennantnameValue : imcNameSelected}/${serviceIdSelected}`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                //console.log(JSON.stringify(response.data));
                //console.log(response.data);
                setUsersData(response.data);
            })
            .catch((error) => {
                //console.log(error);
            });
    };
    useEffect(() => {
        if (tennantDetails) {

            getadditionalQuestions(bearerToken);
        }
    }, [tennantDetails]);

    const add = (user) => {
        const d = new Date();

        user.questionId = 'L1_' + serviceIdSelected + '_' + users.length + Math.floor(Math.random() * 99 + 1) + d.getTime();
        setUsersData([...users, user]);
    };

    const deleteU = (questionId) => {
        setEditing(false);

        setUsersData(users.filter((user) => user.questionId !== questionId));
    };
    // const handleRoleChange = (event) => {
    // 	setYes(event.target.value);
    // };

    const update = (questionId, updatedUser) => {
        setEditing(false);

        setUsersData(users.map((user) => (user.questionId === questionId ? updatedUser : user)));
    };

    const saveAndSubmit = (e) => {
        const axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': bearerToken,
            },
        };
        const questionData = JSON.stringify({
            serviceId: serviceIdSelected,
            // "serviceId":479,
            additionalQuestion: [...users],
        });
        ////console.log(questionData,users);

        axios
            .put(`${CommonConfig.dev.baseUrl1}/api/itr/additional-question/${(usertype === 'Ultimate Client' || usertype === 'EM') ? tennantnameValue : imcNameSelected}`, questionData, axiosConfig)
            .then((response) => {
                //console.log(response.status);
                if (response.status === 200) {
                    history.push('/menu/checkListGenerator');
                }
            })
            .catch((error) => {
                // console.error('There was an error!', error.response.data);
            });
    };

    const back = () => {
        history.push('/menu/checkListGenerator');
    }

    const editRow = (user) => {
        setEditing(true);
        setCurrentUser({
            questionId: user.questionId,
            questionText: user.questionText,
            response: '',
            isAttachmentRequired: user.isAttachmentRequired,
            attachmentUrls: [],
            relevantFlag: '',
            relevanceResponseCRC: '',
            relevanceRemarksCRC: '',
            relevanceResponseAM: '',
            relevanceRemarksAM: '',
            autoPopulate: 'true',
        });
    };

    return (
        <div className="add-additional">
            <div>
                {isEditing ? (
                    <React.Fragment>
                        <Card>
                            <CardContent>
                                <CardHeader title="Edit Question" />
                                <EditForm editing={isEditing} setEditing={setEditing} currentUser={currentUser} updateUser={update} />
                            </CardContent>
                        </Card>
                    </React.Fragment>
                ) : (
                        <React.Fragment>
                            <Card>
                                <CardContent>
                                    <CardHeader title="Add Additional Questions"
                                    // subheader={serviceIdSelected.toString()} 
                                    />
                                    <InputForm addUser={add} />
                                </CardContent>
                            </Card>
                        </React.Fragment>
                    )}
            </div>
            <div>
                <TableUser users={users} editRow={editRow} deleteUser={deleteU} />
            </div>
            <div className="add-button-btm">
                <Button variant="outlined" onClick={back} color="primary">
                    Back
                </Button> <Button variant="outlined" onClick={saveAndSubmit} color="primary">
                    Save
                </Button>
            </div>
        </div>
    );
}
